// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

import { type Scope } from "~/hooks/useScope";
import { LIST_WIF_AUTH_BINDINGS } from "./action";

export function canListWifAuthBindings(scope: Scope): boolean {
  return scope.iamActions.includes(LIST_WIF_AUTH_BINDINGS);
}
